const slots = {}

export default class FirstWins {
  slot: string | undefined | null
  constructor(slot : string | undefined | null) {
    this.slot = slot
  }
  wins(value : any) {
    if(!value || !this.slot) return value
    if(!slots[this.slot]) {
      slots[this.slot] = this
      return value
    }
    return slots[this.slot] === this && value
  }
  release() {
    if(!this.slot || slots[this.slot] !== this) { return false }
    return delete slots[this.slot]
  }
}